import React from "react";
import { Button } from "@material-ui/core";

interface IMddStudySiteSaveButtonProps {
  onSave: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled: boolean;
  buttonText?: string;
}

export const MddStudySiteSaveButton = ({
  onSave,
  disabled,
  buttonText = "Save"
}: IMddStudySiteSaveButtonProps): JSX.Element => {
  return (
    <div className="mdd-study-site--save-button-section mdd-study-site--save-button-section--sticky">
      <Button
        className="mdd-study-site--save-button"
        id="saveButtonId"
        color="primary"
        disableFocusRipple
        disableRipple
        variant="contained"
        onClick={onSave}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </div>
  );
};
